import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import clsx from 'clsx';
import { getFreezeProps } from "./table-freeze.utils";
import { OverlayTrigger, Tooltip } from '@isyc-react/design/bootstrap';
import { useTranslation } from 'react-i18next';
import { nstable } from "../../../i18n/namespaces";
import '@isyc-react/design/main';
import "./table.style.scss";
export const TableBody = props => {
  const {
    instance
  } = props;
  const {
    getTableBodyProps,
    page,
    prepareRow,
    visibleColumns
  } = instance;
  const {
    t
  } = useTranslation(nstable.common);
  //console.log('instance', instance)

  const cellPropGetter = React.useCallback((cells, cell, index) => {
    const columns = cells.map(col => col.column);
    const column = cell.column;
    const grouped = visibleColumns.some(vc => vc.isGrouped);
    const style = {
      minWidth: column.minWidth,
      width: column.width,
      maxWidth: column.maxWidth
    };
    const className = clsx({
      'cell-is-grouped': cell.isGrouped,
      'cell-is-aggregated': cell.isAggregated,
      'cell-is-placeholder': cell.isPlaceholder
    });
    if (!grouped && column.freeze) {
      const {
        style: freezeStyle,
        className: freezeClassName
      } = getFreezeProps(columns, index);
      return {
        className: clsx(className, 'column-freeze-cell', freezeClassName),
        style: _objectSpread(_objectSpread({}, style), freezeStyle)
      };
    }
    return {
      className,
      style
    };
  }, [visibleColumns]);
  return /*#__PURE__*/React.createElement("tbody", getTableBodyProps(), page.map((row, i) => {
    prepareRow(row);
    //TODO: Conseguir pasar la clase por props o contexto (QUITAR CONTEXTO DEPRECATED PORFAVOR!!!)
    return /*#__PURE__*/React.createElement("tr", _extends({}, row.getRowProps(), {
      className: clsx({
        'selected-row': row.isSelected
      }),
      key: i
    }), row.cells.map((cell, index) => {
      return /*#__PURE__*/React.createElement("td", _extends({}, cell.getCellProps(cellPropGetter(row.cells, cell, index)), {
        key: index
      }), cell.isGrouped ?
      /*#__PURE__*/
      // If it's a grouped cell, add an expander and row count
      React.createElement("div", {
        className: "d-flex flex-row align-items-center justify-content-start"
      }, /*#__PURE__*/React.createElement(OverlayTrigger, {
        delay: {
          show: 500,
          hide: 0
        },
        overlay: /*#__PURE__*/React.createElement(Tooltip, null, t('table.body.row.expand.toggle'))
      }, /*#__PURE__*/React.createElement("div", _extends({}, row.getToggleRowExpandedProps({
        title: undefined
      }), {
        style: {
          marginRight: '5px'
        }
      }), row.isExpanded ? /*#__PURE__*/React.createElement("i", {
        className: "mdi mdi-chevron-down cursor-pointer font-size-18"
      }) : /*#__PURE__*/React.createElement("i", {
        className: "mdi mdi-chevron-right cursor-pointer font-size-18"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "d-flex flex-row align-items-center"
      }, /*#__PURE__*/React.createElement("div", null, cell.render('Cell')), /*#__PURE__*/React.createElement("div", {
        style: {
          marginLeft: '5px'
        }
      }, "(", row.subRows.length, ")"))) : cell.isAggregated ?
      // If the cell is aggregated, use the Aggregated
      // renderer for cell
      cell.render('Aggregated') : cell.isPlaceholder ? null :
      // For cells with repeated values, render null
      // Otherwise, just render the regular cell
      cell.render('Cell'));
    }));
  }));
};